/**
 * SmSlider.js — 2-up card slider with dots-only pagination (no arrows)
 */
import Swiper from 'swiper';
import { Pagination } from 'swiper/modules';

export default class SmSlider {
  constructor(selector = '.sm-slide') {
    this.el = document.querySelector(selector);
    if (!this.el) return;

    this.swiper = new Swiper(this.el, {
      modules: [Pagination],
      slidesPerView: 1.25,
      spaceBetween: 16,
      breakpoints: {
        480: { slidesPerView: 2 },
      },
      pagination: {
        el: this.el.querySelector('.swiper-pagination'),
        clickable: true,
      },
    });
  }
}
